import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

class WebComponent extends HTMLElement {
  connectedCallback() {
    const promoId = this.getAttribute('promoId');
    const promoContent = this.getAttribute('promoContent');
    const promoRule = this.getAttribute('promoRule');
    const promoLink = this.getAttribute('promoLink');
    if (promoId && promoContent && promoRule && promoLink) {
      ReactDOM.render(
        <App promoId={promoId} promoContent={promoContent} promoRule={promoRule} promoLink={promoLink} />,
        this,
      );
    } else {
      console.error('Invalid optin configuration.');
    }
  }
}

const ELEMENT_ID = 'voebiz-react-optin';

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
